import React from 'react';
// import propTypes from 'prop-types';

import { normalizeURL, isValidURL } from '@common/utils/url';
import CodeChef from '@profile/images/svg/social/CodeChef.svg';
import CodeForces from '@profile/images/svg/social/Codeforces.svg';
import GitHub from '@profile/images/svg/social/GitHub.svg';
import HackerRank from '@profile/images/svg/social/HackerRank.svg';
import LinkedIn from '@profile/images/svg/social/LinkedIn.svg';
import SPOJ from '@profile/images/svg/social/SPOJ.svg';
import TopCoder from '@profile/images/svg/social/TopCoder.svg';
import InterviewBit from '@profile/images/svg/social/InterviewBit.svg';
import HackerEarth from '@profile/images/svg/social/HackerEarth.svg';

const socialMapping = {
  codechef: { name: 'CodeChef', icon: CodeChef },
  codeforces: { name: 'Codeforces', icon: CodeForces },
  github: { name: 'GitHub', icon: GitHub },
  hackerrank: { name: 'HackerRank', icon: HackerRank },
  linkedin: { name: 'LinkedIn', icon: LinkedIn },
  spoj: { name: 'SPOJ', icon: SPOJ },
  topcoder: { name: 'TopCoder', icon: TopCoder },
  interviewbit: { name: 'InterviewBit', icon: InterviewBit },
  hackerearth: { name: 'HackerEarth', icon: HackerEarth },

};

function SocialProfiles({ profiles, showHeader = true }) {
  const parsedProfiles = {};
  Object.keys(profiles).forEach(key => {
    if (!profiles[key]) {
      return;
    }

    const url = normalizeURL(profiles[key]);
    if (profiles[key] && isValidURL(url)) {
      parsedProfiles[key] = url;
    }
  });

  function socialUI(platform, url) {
    const { name, icon } = socialMapping[platform] || {};

    if (!url || !name || !icon) {
      return null;
    }

    return (
      <div className="profile-sidebar__social-row" key={platform}>
        <img src={icon} alt={name} className="profile-sidebar__social-icon" />
        <a
          href={url}
          className="profile-sidebar__social-link"
          onClick={() => window.trackGaEvent('ProfilePage', 'Social', name)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {name}
        </a>
      </div>
    );
  }
  if (!Object.keys(parsedProfiles).length) {
    return null;
  }

  return (
    <div className="profile-sidebar__social">
      { showHeader
        ? (
          <h3 className="profile-sidebar__social-header">
            Social Profiles
          </h3>
        )
        : null }
      {Object.keys(parsedProfiles)
        .map((key) => socialUI(key, parsedProfiles[key]))}
    </div>
  );
}


export default SocialProfiles;
